import { render, staticRenderFns } from "./PaginatedSortableTable.vue?vue&type=template&id=f5d27b96&scoped=true"
import script from "./PaginatedSortableTable.vue?vue&type=script&lang=ts"
export * from "./PaginatedSortableTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d27b96",
  null
  
)

export default component.exports